module.exports = __webpack_public_path__ + "static/media/couple.b4c29c78.jpg";